<template>
  <div
    v-if="adsDisabled || !spaceId"
    class="d-none"
  ></div>
  <span
    v-else-if="adSystem === AdSystem.SMART_AD"
    :id="`container${spaceId}`"
    ref="adContainer"
  ></span>
  <div v-else-if="adSystem === AdSystem.FREEWHEEL">
    <span
      :id="spaceId"
      class="_fwph"
    >
      <form
        :id="`_fw_form_${spaceId}`"
        style="display:none"
      >
        <input
          :id="`_fw_input_${spaceId}`"
          type="hidden"
          :name="`_fw_input_${spaceId}`"
          :value="slotParams"
        >
      </form>
      <span
        :id="`_fw_container_${spaceId}`"
        ref="adContainer"
        class="_fwac"
      ></span>
    </span>
  </div>
</template>
<script>
  import { AdSystem } from '@/shared/enums';
  import subtreeMixin from '@/index/shared/mixins/subtree-mixin';

  export default {
    name: 'AdBanner',
    enums: {
      AdSystem,
    },
    mixins: [
      subtreeMixin,
    ],
    props: {
      adSystem: {
        type: String,
        required: true,
      },
      autoLoad: {
        type: Boolean,
        default: true,
      },
      slotParams: {
        type: String,
        default: '',
      },
      spaceId: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        subscriber: this.$services.resolve('subscriber'),
      };
    },
    computed: {
      adsDisabled() {
        return this.subscriber.isNoAds;
      },
    },
    mounted() {
      if (this.adsDisabled || !this.spaceId) {
        this.$emit('isEmpty', true);
        return;
      }

      this.observe(this.$refs.adContainer);
      this.loadAd();
    },
    methods: {
      loadAd() {
        if (this.adSystem === AdSystem.SMART_AD) {
          this.$smartad.load(this.spaceId);
        } else if (this.adSystem === AdSystem.FREEWHEEL) {
          this.$freewheel.reload();
        }
      },
      onSubtreeModification() {
        const adChildNodes = this.$refs.adContainer?.childNodes;
        const elArray = adChildNodes?.length ? Object.values(adChildNodes).filter((node) => {
          return node.tagName !== 'SCRIPT';
        }) : [];

        this.$emit('isEmpty', !elArray.length);
      },
    },
  };
</script>
